/* eslint-disable */
import 'bootstrap/js/src/dropdown.js';
import 'bootstrap/js/src/collapse.js';

(function (jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.mainMenu = {
    attach: function (context, settings) {
      // Elements
      const $globalHeader = jQuery('.global-header');
      const $headerBehind = jQuery('.global-header-behind');
      const $mainNav = $globalHeader.find('.navbar-main');
      const $secondNav = jQuery('#block-secondary-navigation');
      const $utilityNav = jQuery('#block-headerutility');
      const $navToggle = jQuery('.navbar-toggler');
      const $navToggleIcon = jQuery('.navbar-toggler-icon');
      const $navToggleText = jQuery('.navbar-toggler-text');
      // Classes
      const headerTopClass = 'global-header-top';
      const headerTopTransitionClass = 'global-header-top-transition';
      // Transition speeds
      const transitionSpeed = 350;
      const bpHeaderTop = window.breakpoints.xl;

      /**
       * Add class if not already present
       */
      function addClassSafe($el, classname) {
        if (!$el.hasClass(classname)) {
          $el.addClass(classname);
        }
      }

      /**
       * Remove class if present
       */
      function removeClassSafe($el, classname) {
        if ($el.hasClass(classname)) {
          $el.removeClass(classname);
        }
      }

      /**
       * Remove old class, add new class
       */
      function swapClassSafe($el, oldClassName, newClassName) {
        removeClassSafe($el, oldClassName);
        addClassSafe($el, newClassName);
      }

      /**
       * Convert CSS columns into individual column divs
       * Keep element flow provided by CSS
       * but allow expanding sub-navs without causing text to re-flow
       */
      function navColumns() {
        jQuery('#secondary-menu .nav:not(.columns-fixed)').each(function() {
          const $nav = jQuery(this);
          const c = parseInt($nav.css('column-count'));
          if (c > 1) {
            let p = Math.ceil($nav.children().length / c);
            const $columns = jQuery('<div></div>');
            // copy all attributes to new div
            var attributes = $nav.prop('attributes');
            jQuery.each(attributes, function() {
              $columns.attr(this.name, this.value);
            });
            $columns.attr('role', 'navigation');
            addClassSafe($columns, 'columns-fixed');

            for (let i = 1; i < (c + 1); i++) {
              var $col = jQuery('<ul class="column column-' + i + '"></ul>');
              $col.append($nav.children().slice(0, p));
              $columns.append($col);
            }
            $nav.replaceWith($columns);
          }
        });
      }

      function utilityNavPosition() {
        if (window.innerWidth <= window.breakpoints.xl && !($mainNav.find($utilityNav).length > 0)) {
          $mainNav.prepend($utilityNav);
        }
        else if (window.innerWidth > window.breakpoints.xl && $mainNav.find($utilityNav).length > 0) {
          $globalHeader.find('.region-global-header').append($utilityNav);
        }
      }

      // JBB - 2023-12-18 - hack this to account for new favorites heart icon
      function centerSearch() {
        const $search = jQuery('#block-nowfoodssearchblock');
        if ($search.length > 0) {
          if (window.innerWidth > window.breakpoints.xl) {
            var mR = parseFloat($search.css('margin-right'));
            var oR = $search.offset().left + ($search.width() / 2);
            var wC = window.innerWidth / 2;
            // mR = mR - (wC - oR);
            mR = mR - (wC - oR) + 40;
            // set a fixed margin-right and auto margin-left to center search
            $search.css({ 'margin-right': mR + 'px' });
          }
          else {
            $search.css({ 'margin-right': '' });
          }
        }
      }

      /**
       * Helper function to check if the current path is in commerce
       */
      function isCommerce() {
        return (jQuery('body').hasClass('path-checkout') || jQuery('body').hasClass('path-cart'));
      }

      /**
       * Helper function to check header classes.
       */
      function isHeaderTop() {
        if (isCommerce()) {
          return false;
        }
        if (jQuery(window).scrollTop() < 1 && window.innerWidth > bpHeaderTop) {
          return true;
        }
        if ($globalHeader.hasClass(headerTopClass)) {
          return true;
        }
        if ($globalHeader.hasClass(headerTopTransitionClass)) {
          return true;
        }
        return false;
      }

      /**
       * Collapse Primary and Secondary navs
       */
      function collapseAllNavs() {
        collapseMainNav();
        collapseSecondaryNav();
      }

      /**
       * Collapse Primary nav
       */
      function collapseMainNav(all = false) {
        if (!isHeaderTop() || all) {
          $mainNav.collapse('hide');
          switchToggle(true);
        }
        else {
          $mainNav.find('.collapse.show').collapse('hide');
        }
      }

      /**
       * Collapse Secondary nav
       */
      function collapseSecondaryNav() {
        $secondNav.find('.collapse').collapse('hide');
      }

      /**
       * Calculate the height and distance from the top of the page for menus
       */
      function headerNavHeight() {
        const style = {
          'height': '',
          'top': ''
        };
        const winH = window.innerHeight;
        let headH = 0;
        let navH = 0;
        headH = Math.floor($globalHeader.height());
        navH = Math.ceil(winH - headH) + 45;

        if (!isHeaderTop()) {
          style.height = navH + 'px';
          style.top = headH + 'px';
        }
        $mainNav.css(style);
        $mainNav.find('.dropdown-container').each(function() {
          const $dropdown = jQuery(this);
          // don't do this for header utility
          if ($dropdown.closest('.menu--header-utility').length === 0) {
            $dropdown.css(style);
          }
          else {
            $dropdown.css({ 'height': 0 });
            var h = $dropdown[0].scrollHeight;
            h = h - parseInt($dropdown.css('padding-top'));
            h = h - parseInt($dropdown.css('padding-bottom'));
            $dropdown.css({ 'height': h + 'px' });
          }
        });
      }

      /**
       * Re-order header blocks when they change visual order
       *
       * Sort to original DOM order (data-order)
       * Then sort based on css flex order.
       */
      function headerTabIndexFix() {
        const $headerRegion = $globalHeader.find('.region-global-header');
        const $headerBlocks = $headerRegion.children();
        // Track the blocks' original order
        if (!$headerBlocks.first().attr('data-order')) {
          $headerBlocks.each(function (i) {
            const $block = jQuery(this);
            $block.attr('data-order', i);
          });
        }
        // sort by DOM order
        $headerBlocks
          .sort(function (a, b) {
            const $a = jQuery(a);
            const $b = jQuery(b);
            let orderA = parseInt($a.attr('data-order'));
            let orderB = parseInt($b.attr('data-order'));
            return (orderA < orderB) ? -1 : (orderA > orderB) ? 1 : 0;
          })
          // Sort by flex order
          .sort(function (a, b) {
            const $a = jQuery(a);
            const $b = jQuery(b);
            let orderA = parseInt($a.css('order'));
            let orderB = parseInt($b.css('order'));
            return (orderA < orderB) ? -1 : (orderA > orderB) ? 1 : 0;
          })
          // Re-order within the DOM to match visual order
          .appendTo($headerRegion);
      }

      /**
       * Move the page title and secondary navigation
       *
       * When the user scrolls past either element, move them to the header
       * Keep a record of the previous position.
       * When the user returns to the previous position, put them back.
       */
      function secondaryNavScroll(scrollTop) {
        const sT = scrollTop + $globalHeader.height();
        const $pageTitle = jQuery('#block-sd-page-title');
        const $secondaryMenu = jQuery('#block-secondary-navigation');
        const $headerRegion = jQuery('.region-global-header-bottom');
        let pToB; // Page Title Offset Bottom
        let sMoB; // Secondary Menu Offset Bottom

        if ($pageTitle.parent().parent().hasClass('region-content-header')) {
          pToB = $pageTitle.offset().top + $pageTitle.height();
          // title is in content
          if (sT > (pToB)) {
            $headerRegion.attr('data-title-offset', pToB);
            const $titlePlaceholder = jQuery('<div id="title-placeholder"></div>');
            var titleHeight = $pageTitle.height();
            $titlePlaceholder.css({ 'height': titleHeight + 'px' });
            $titlePlaceholder.attr('class', $pageTitle.attr('class'));
            $pageTitle.before($titlePlaceholder);
            $titlePlaceholder.css({ 'height': $pageTitle.offset().height + 'px' });
            $headerRegion.prepend($pageTitle);
          }
        }
        else {
          pToB = parseInt($headerRegion.attr('data-title-offset'));
          if (sT < pToB) {
            $headerRegion.attr('data-title-offset', '');
            const $titlePlaceholder = jQuery('#title-placeholder');
            $titlePlaceholder.before($pageTitle);
            $titlePlaceholder.remove();
          }
        }


        if ($secondaryMenu.is(':visible')) { // if not, leave it alone
          if ($secondaryMenu.parent().parent().hasClass('region-content-header')) {
            sMoB = $secondaryMenu.offset().top + $secondaryMenu.height();
            // title is in content
            if (sT > (sMoB)) {
              $headerRegion.attr('data-secondary-menu-offset', sMoB);
              const $menuPlaceholder = jQuery('<div id="secondary-menu-placeholder"></div>');
              var menuHeight = $secondaryMenu.height();
              $menuPlaceholder.css({ 'height': menuHeight + 'px' });
              $menuPlaceholder.attr('class', $secondaryMenu.attr('class'));
              $secondaryMenu.before($menuPlaceholder);
              $menuPlaceholder.css({ 'height': $secondaryMenu.offset().height + 'px' });
              $headerRegion.append($secondaryMenu);
            }
          }
          else {
            sMoB = parseInt($headerRegion.attr('data-secondary-menu-offset'));
            if (sT < sMoB) {
              $headerRegion.attr('data-secondary-menu-offset', '');
              const $menuPlaceholder = jQuery('#secondary-menu-placeholder');
              $menuPlaceholder.before($secondaryMenu);
              $menuPlaceholder.remove();
            }
          }
        }

        if ($headerRegion.children().length > 0) {
          addClassSafe($headerRegion, 'region-visible');
        }
        else if ($headerRegion.children().length === 0) {
          removeClassSafe($headerRegion, 'region-visible');
        }
      }

      /**
       * Transition adding or removing header top class
       */
      function headerTopTransition(isTop) {
        if (!isCommerce() && isTop && window.innerWidth > bpHeaderTop) {
          $mainNav.collapse('show');
          if (!$globalHeader.hasClass(headerTopTransitionClass)) {
            addClassSafe($globalHeader, headerTopTransitionClass);
            setTimeout(function() {
              addClassSafe($globalHeader, headerTopClass);
              removeClassSafe($globalHeader, headerTopTransitionClass);
            }, transitionSpeed);
          }
          // force subnavs to be large enough to fit content
          $mainNav.find('.nav-item--level-0 > .collapse').each(function() {
            const $dd = jQuery(this);
            if ($dd.hasClass('mega-menu')) {
              return;
            }

            $dd.addClass('show-check');
            $dd.css({ 'max-width': 0, 'width': 0 });
            let scrollWidth = $dd[0].scrollWidth;
            if ($dd.hasClass('two-column')) {
              scrollWidth = 2 * scrollWidth;
            }
            scrollWidth += 64;
            $dd.css({ 'max-width': scrollWidth + 'px', 'width': scrollWidth + 'px' });

            // check if the menu runs off screen, align right if so.
            if (($dd.offset().left + $dd.width()) > window.innerWidth) {
              $dd.css({ 'right': $dd.css('left'), 'left': 'unset' });
            }

            $dd.removeClass('show-check');
          });
        }
        else if ($globalHeader.hasClass(headerTopClass)) {
          collapseMainNav(true);
          addClassSafe($globalHeader, headerTopTransitionClass);
          removeClassSafe($globalHeader, headerTopClass);
          setTimeout(function() {
            removeClassSafe($globalHeader, headerTopTransitionClass);
          }, transitionSpeed);
          $mainNav.find('.nav-item--level-0 > .dropdown-container').each(function() {
            const $dd = jQuery(this);
            $dd.removeAttr('style');
          });
        }

        headerNavHeight();
      }

      /**
       * Make transitions based on scroll position and window width.
       */
      function menuCheckScrollPosition() {
        const scroll = jQuery(window).scrollTop();
        if (scroll === 0) {
          headerTopTransition(true);
        }
        else {
          headerTopTransition(false);
        }
        secondaryNavScroll(scroll);
      }

      /**
       * Move focus from one toggle to the other to try to keep a logical tab-order
       * Then hide the one not in use.
       */
      function switchToggle(expanded) {
        if (expanded) {
          swapClassSafe($navToggleIcon, 'fa-times', 'fa-bars');
          $navToggleText.text('Menu');
          removeClassSafe(jQuery('body'), 'menu-open');
        }
        else {
          swapClassSafe($navToggleIcon, 'fa-bars', 'fa-times');
          $navToggleText.text('Close');
          // add class to tab capture
          setTimeout(function() {
            addClassSafe(jQuery('body'), 'menu-open');
          }, 250);
        }
      }

      function matchDeepest($parent, childSelector) {
        let $target = $parent.find(childSelector);
        let $next = $target;

        while ($next.length) {
          $target = $next;
          $next = $next.find(childSelector);
        }
        return $target;
      }

      /**
       * Set the tab-index, but keep any previous value accessible
       */
      function tabSet($el, v) {
        if ($el.attr('data-tabindex') === undefined) {
          let i = $el.attr('tabindex');
          if (i) {
            $el.attr('data-tabindex', i);
          }
        }
        $el.attr('tabindex', v);
      }

      /**
       * Remove from the tab-order
       */
      function tabHidden($el) {
        tabSet($el, -1);
      }

      /**
       * Revert to a previous tab-index, or remove the attribute completely
       */
      function tabDefault($el) {
        let i = $el.attr('data-tabindex');
        if (i) {
          $el.attr('tabindex', i);
        }
        else {
          $el.removeAttr('tabindex');
        }
        $el.removeAttr('data-tabindex', '');
      }

      /**
       * Remove tabindex from elements outside of the header to keep focus trapped
       */
      function headerFocusTrap() {

        setTimeout(function() {
          const menuOpen = $mainNav.hasClass('show');
          // get everything else in the DOM that's tab-able
          const $tabbables = jQuery('.main-content, .global-footer').find('a, area, input, select, textarea, button, iframe, [tabindex], [contentEditable=true]');
          $tabbables.each(function (i) {
            const $tab = jQuery(this);
            if (menuOpen && !isHeaderTop()) {
              tabHidden($tab);
            }
            else {
              tabDefault($tab);
            }
          });
          $mainNav.find('a, button').each(function (i) {
            const $tab = jQuery(this);
            tabDefault($tab);
          });

          if (menuOpen) {
            let $dropdowns = $mainNav.find('.dropdown-container.show');
            let $deepestNav = matchDeepest($mainNav, '.dropdown-container.show');
            let $pageHeader = $globalHeader.find('.page-header');
            if (window.innerWidth <= window.breakpoints.md) {
              // Hide all
              $mainNav.find('a, button').each(function (i) {
                const $tab = jQuery(this);
                tabHidden($tab);
              });
              // Show deepest
              $deepestNav.find('a, button').each(function (i) {
                const $tab = jQuery(this);
                tabSet($tab, 2);

              });
            }
            else if (!isHeaderTop()) {
              // Medium hide all subnavs but the deepest
              $dropdowns.find('a, button').each(function (i) {
                const $tab = jQuery(this);
                tabHidden($tab);
              });
              // Show page Header
              $pageHeader.find('a, button').each(function (i) {
                const $tab = jQuery(this);
                tabDefault($tab);
              });
              // Show deepest
              $deepestNav.find('a, button').each(function (i) {
                const $tab = jQuery(this);
                tabDefault($tab);
              });
            }
          }
        }, 500);
      }

      // find other menus open
      function menusOpen() {
        let menusAreOpen = false;
        // mobile nav is open
        if ($mainNav.hasClass('show') && !isHeaderTop()) {
          menusAreOpen = true;
        }
        // mobile sub-nav is open
        if ($mainNav.find('.nav-item--level-1 > .show').length > 0) {
          menusAreOpen = true;
        }
        // secondary sub-nav is open
        if (jQuery('.secondary-menu .nav-item--level-0 > .show').length > 0) {
          menusAreOpen = true;
        }
        return menusAreOpen;
      }

      function showHeaderBehind(visible = false) {
        setTimeout(function() {
          if (!menusOpen()) {
            if (!isHeaderTop() || visible) {
              addClassSafe($headerBehind, 'visible');
            }
            else {
              addClassSafe($headerBehind, 'non-visible');
            }
          }
        }, 200);
      }

      function hideHeaderBehind() {
        setTimeout(function() {
          if (!menusOpen()) {
            removeClassSafe($headerBehind, 'visible');
            removeClassSafe($headerBehind, 'non-visible');
          }
        }, 200);
      }

      /**
       * EVENTS
       */

      const menuEventsInit = function() {

        // Any nav show
        jQuery('#navbarGlobalMain').on('show.bs.collapse', function (e) {
          if (!isHeaderTop()) {
            showHeaderBehind();
          }
        });

        jQuery('#navbarGlobalMain .nav-item--level-0 > .collapse').on('show.bs.collapse', function (e) {
          showHeaderBehind();
          var $menu = jQuery(e.target);
          var $openSiblings = $menu.parent().siblings('.nav-item--level-0').find('.collapse.show');
          $openSiblings.collapse('hide');
        });

        jQuery('.secondary-menu .nav-item--level-0 > .collapse').on('show.bs.collapse', function (e) {
          showHeaderBehind(true);
        });

        // Any nav hide
        jQuery('#navbarGlobalMain, #navbarGlobalMain .nav-item--level-0 > .collapse, .secondary-menu .nav-item--level-0 > .collapse').on('hide.bs.collapse', function (e) {
          // collapse any children at the same time;
          const $target = jQuery(e.target);
          $target.hide();
          $target.find('.collapse.show').collapse('hide');
          $target.show();
          hideHeaderBehind();
        });

        // Secondary nav only allow one top level item open
        jQuery('.secondary-menu .nav-item--level-0 > .collapse').on('show.bs.collapse', function (e) {
          const $target = jQuery(e.target);
          $target.parent().siblings('.nav-item--level-0').find('.collapse.show').collapse('hide');
        });


        // Main nav show
        $globalHeader.find('.nav, .navbar-main, .dropdown-container').on('show.bs.collapse', function (e) {
          headerFocusTrap();
          headerNavHeight();
        });

        // Main nav hide
        $globalHeader.find('.nav, .navbar-main, .dropdown-container').on('hide.bs.collapse', function (e) {
          headerFocusTrap();
        });

        jQuery('.dropdown-container .nav-link').blur(function (e) {
          const $container = jQuery(this).closest('.dropdown-container');
          setTimeout(function() {
            if ($container.find(document.activeElement).length === 0) {
              $container.collapse('hide');
            }
          }, 0);
        });

        $navToggle.click(function() {
          const expanded = $navToggle.attr('aria-expanded') === 'true';
          switchToggle(expanded);
        });

        $headerBehind.click(function() {
          collapseAllNavs();
        });
      };

      const menuReady = function() {
        menuEventsInit();
        utilityNavPosition();
        menuCheckScrollPosition();
        headerTabIndexFix();
        centerSearch();
        navColumns();
        hideHeaderBehind();
      };

      const menuResize = function() {
        const focusTarget = document.activeElement;
        collapseAllNavs();
        utilityNavPosition();
        menuCheckScrollPosition();
        headerTabIndexFix();
        centerSearch();
        // refocus focused element
        if (focusTarget) {
          focusTarget.focus();
        }
      };

      // Directly call menuReady if 'menu' is ready
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        menuReady('menu');
      } else {
        document.addEventListener('DOMContentLoaded', () => menuReady('menu'));
      }

      // Add event listener for resize
      window.addEventListener('resize', menuResize);

      // Add event listener for scroll
      window.addEventListener('scroll', menuCheckScrollPosition);

      // should start at 0
      let $position = jQuery(window).scrollTop();
      jQuery(window).scroll(function() {
        let scroll = jQuery(window).scrollTop();
        if (scroll > $position && !jQuery('#page-header').hasClass('global-header-tucked') && jQuery(window).scrollTop() > 100) {
          jQuery('#page-header').addClass('global-header-tucked');
        }
        else if (scroll < $position && jQuery('#page-header').hasClass('global-header-tucked')) {
          jQuery('#page-header').removeClass('global-header-tucked');
        }
        $position = scroll;
      });


      let $search_input = jQuery("#nowfoods-search-now-foods-search-block input[type='search']");

      // Prevent empty submissions
      jQuery("#nowfoods-search-now-foods-search-block").submit(function (e) {
        if ($search_input.val() === '') {
          e.preventDefault();
        }
      });

      // if a string is entered into the search input, show the submit button
      $search_input.on('input', function() {
        if ($search_input.val().length > 0) {
          jQuery('#nowfoods-search-now-foods-search-block').addClass('search-query');
        }
        else {
          jQuery('#nowfoods-search-now-foods-search-block').removeClass('search-query');

        }
      });
    }
  };
})(jQuery, Drupal);
